import * as React from "react";
var WidgetHeader = function (_a) {
    var title = _a.title;
    return (React.createElement("div", { className: "sfo-header" },
        React.createElement("h1", { className: "cs-column-title" }, title)));
};
export default WidgetHeader;
